interface Country {
  name: string;
  alpha2: string;
  locale?: string;
}

// @NOTE-RT: Expose an interface similar to https://www.npmjs.com/package/country-data-list, but smaller
export const all: Country[] = [
  {
    name: 'Australia',
    alpha2: 'AU',
  },
  {
    name: 'Austria',
    alpha2: 'AT',
  },
  {
    name: 'Argentina',
    alpha2: 'AR',
  },
  {
    name: 'Belgium',
    alpha2: 'BE',
  },
  {
    name: 'Brazil',
    alpha2: 'BR',
  },
  {
    name: 'Bolivia',
    alpha2: 'BO',
  },
  {
    name: 'Bulgaria',
    alpha2: 'BG',
  },
  {
    name: 'Canada',
    alpha2: 'CA',
  },
  {
    name: 'Chile',
    alpha2: 'CL',
  },
  {
    name: 'China',
    alpha2: 'CN',
  },
  {
    name: 'Colombia',
    alpha2: 'CO',
  },
  {
    name: 'Costa Rica',
    alpha2: 'CR',
  },
  {
    name: 'Croatia',
    alpha2: 'HR',
  },
  {
    name: 'Cyprus',
    alpha2: 'CY',
  },
  {
    name: 'Czechia',
    alpha2: 'CZ',
  },
  {
    name: 'Denmark',
    alpha2: 'DK',
  },
  {
    name: 'Dominican Republic',
    alpha2: 'DO',
  },
  {
    name: 'Estonia',
    alpha2: 'EE',
  },
  {
    name: 'Finland',
    alpha2: 'FI',
  },
  {
    name: 'France',
    alpha2: 'FR',
  },
  {
    name: 'Germany',
    alpha2: 'DE',
  },
  {
    name: 'Greece',
    alpha2: 'GR',
  },
  {
    name: 'Hungary',
    alpha2: 'HU',
  },
  {
    name: 'Hong Kong',
    alpha2: 'HK',
  },
  {
    name: 'India',
    alpha2: 'IN',
  },
  {
    name: 'Indonesia',
    alpha2: 'ID',
  },
  {
    name: 'Ireland',
    alpha2: 'IE',
  },
  {
    name: 'Israel',
    alpha2: 'IL',
  },
  {
    name: 'Italy',
    alpha2: 'IT',
  },
  {
    name: 'Japan',
    alpha2: 'JP',
  },
  {
    name: 'Kazakhstan',
    alpha2: 'KZ',
  },
  {
    name: 'Latvia',
    alpha2: 'LV',
  },
  {
    name: 'Lithuania',
    alpha2: 'LT',
  },
  {
    name: 'Luxembourg',
    alpha2: 'LU',
  },
  {
    name: 'Malaysia',
    alpha2: 'MY',
  },
  {
    name: 'Malta',
    alpha2: 'MT',
  },
  {
    name: 'Mexico',
    alpha2: 'MX',
  },
  {
    name: 'Netherlands',
    alpha2: 'NL',
  },
  {
    name: 'New Zealand',
    alpha2: 'NZ',
  },
  {
    name: 'Norway',
    alpha2: 'NO',
  },
  {
    name: 'Panama',
    alpha2: 'PA',
  },
  {
    name: 'Philippines',
    alpha2: 'PH',
    locale: 'en-PH',
  },
  {
    name: 'Peru',
    alpha2: 'PE',
  },
  {
    name: 'Poland',
    alpha2: 'PL',
  },
  {
    name: 'Portugal',
    alpha2: 'PT',
  },
  {
    name: 'Puerto Rico',
    alpha2: 'PR',
  },
  {
    name: 'Romania',
    alpha2: 'RO',
  },
  {
    name: 'Russian Federation',
    alpha2: 'RU',
  },
  {
    name: 'Slovenia',
    alpha2: 'SI',
  },
  {
    name: 'Slovakia',
    alpha2: 'SK',
  },
  {
    name: 'Sweden',
    alpha2: 'SE',
  },
  {
    name: 'Singapore',
    alpha2: 'SG',
  },
  {
    name: 'Switzerland',
    alpha2: 'CH',
  },
  {
    name: 'South Africa',
    alpha2: 'ZA',
  },
  {
    name: 'South Korea',
    alpha2: 'KR',
  },
  {
    name: 'Spain',
    alpha2: 'ES',
  },
  {
    name: 'Thailand',
    alpha2: 'TH',
  },
  {
    name: 'Turkey',
    alpha2: 'TR',
  },
  {
    name: 'Ukraine',
    alpha2: 'UA',
  },
  {
    name: 'United Kingdom',
    alpha2: 'GB',
  },
  {
    name: 'United States',
    alpha2: 'US',
  },
  {
    name: 'Vietnam',
    alpha2: 'VN',
  },
];

export const map: { [key: string]: Country } = all.reduce<Record<string, Country>>(
  (mappedCountries, country) => {
    // eslint-disable-next-line no-param-reassign
    mappedCountries[country.alpha2] = country;

    return mappedCountries;
  },
  {}
);

type Countries = { [key: string]: Country } & { all: Country[] };

const countries = { ...map, all } as Countries;

export default countries;
